import './adjust-fp-input-group.scss';
import React, { useCallback, useMemo, useState } from 'react'
import { P2TextLabel } from 'react-bootstrap-common-script';
import AdjustFinancialPlanInput from '../../input/adjust-financial-plan-input/adjust-financial-plan-input';
import InputSlider from "../../input-slider/input-slider"
import { useRef } from 'react';
import { Helpers } from '../../../utils/helper';

interface AdjustFPInputGroupInterface {
  minValue?: number;
  maxValue?: number;
  value: number;
  setValue: (value: number) => void;
  minLabel?: string;
  maxLabel?: string;
  hasDecimal?: boolean;
  hasTooltip?: boolean;
  title?: string;
  prefix?: string;
  postfix?: string;
  inputVariant?: "full" | "small";
  hasDescription?: boolean;
  descriptionContent?: string;
}

const AdjustFPInputGroup = ({ title = "", prefix = "", postfix = "", inputVariant = "full", hasTooltip = false, hasDecimal = false, hasDescription = false, descriptionContent = "", minValue = 0, maxValue = 1, value, setValue, minLabel = "", maxLabel = "", ...props }: AdjustFPInputGroupInterface) => {

  //Internal used
  const [isBlur, setIsBlur] = useState<boolean>(true);


  const DefaultValue = hasDecimal ? "0.00" : "0";

  const ConditionalFormatAmount = useCallback((value: number | string): string => {
    if (hasDecimal) {
      return parseFloat(value.toString()).toFixed(2)
    }
    else {
      return parseInt(value.toString()).toString();
    }
  }, [hasDecimal])

  const formattedAmount = useMemo(() => {
    if (value) {
      return ConditionalFormatAmount(value);
    }
    else {
      return DefaultValue;
    }
  }, [ConditionalFormatAmount, DefaultValue, value])




  const onInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.valueAsNumber;

    if (!value) {
      setValue(0);
    }
    else {
      setValue(value);
    }

  }, [])

  const onSliderChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    let { value, valueAsNumber } = e.target;
    value = value.replace(/[^0-9.]/g, '');

    if (!value) {
      setValue(0);
    }
    else {
      setValue(valueAsNumber);
    }

  }, [])


  const onInputFocus = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setIsBlur(false);
  }, [])

  const onInputBlur = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setIsBlur(true);
    let value = e.target.valueAsNumber;

    if (value) {
      if (value > maxValue) {
        setValue(maxValue);

      }
      else if (value < minValue) {
        setValue(minValue);

      }
      else {
        setValue(value);

      }
    }
    else {
      setValue(minValue);
    }

  }, [ConditionalFormatAmount, maxValue, minValue])

  return (
    <React.Fragment>
      <div className='polymer-adjust-fp-input-group'>
        <div className='polymer-adjust-fp-input-group__top-container'>
          <div>
            <P2TextLabel fontSize={"1.125rem"} bold={700} label={title} hasTooltip={hasTooltip} tooltipContent={<p>ASD</p>} />
          </div>
          <div>
            <AdjustFinancialPlanInput variant={inputVariant} value={isBlur ? formattedAmount : value} prefix={prefix} postfix={postfix} onBlur={onInputBlur} onChange={onInputChange} onFocus={onInputFocus} />
          </div>
        </div>
        <div className='polymer-adjust-fp-input-group__slider-container'>
          <InputSlider min={minValue} max={maxValue} minLabel={minLabel} maxLabel={maxLabel} value={formattedAmount} onChange={onSliderChange} />
        </div>
        {hasDescription && <div className='polymer-adjust-fp-input-group__description-container'>
          <P2TextLabel fontSize={"1.125rem"} bold={400} label={descriptionContent} hasTooltip tooltipContent={<p>ASD</p>} />
        </div>}
      </div>

    </React.Fragment>
  )
}

export default AdjustFPInputGroup

